import { rootGet } from '@chilipiper/service/src/api'
import { useQuery } from '@tanstack/react-query'
import { getExtensionIdResource } from '../utils/env'

// navigator.userAgentData only exists in Chromium browsers — the only ones where a
// chrome-extension:// fetch can succeed, so skip the probe everywhere else
const isChromiumBrowser = () => 'userAgentData' in navigator

export const fetchExtensionInstalled = async () => {
  if (!isChromiumBrowser()) {
    throw new Error('extension probe skipped: not a Chromium browser')
  }
  return rootGet(`chrome-extension://${getExtensionIdResource()}/service-worker-loader.js`, {
    retry: 0,
  }).text()
}

export const useExtensionInstalled = () => {
  return useQuery({
    queryKey: ['is-extension-installed'],
    queryFn: () => {
      return fetchExtensionInstalled()
        .then(() => true)
        .catch(() => false)
    },
  })
}
